<template>
    <div class="SwitchControl">
        <div class="p-title">开关控制</div>
        <div class="p-cont">
            <div class="left">
                <div class="tt"><span>分组列表</span></div>
                <div class="list">
                    <div class="item" @click="checkGroup('all')" :class="{active:noall}">
                        <div class="name">全部</div>
                        <div class="all row-center">
                            <span @click="GroupAllSwitch(true)">一键全开</span>
                            <span @click="GroupAllSwitch(false)">一键全关</span>
                        </div>
                    </div>
                    <div class="item" v-for="(item,index) in leftList" @click="checkGroup('group',item,index)" :key="index" :class="{active:item.active}">
                        <div class="name row-center">
                            <input type="text" v-model="item.groupNameCopy" v-if="item.show" maxlength="8" @click.stop="">
                            <label for="" v-else>{{item.groupName}}</label>
                            <span>
                                <img src="@/assets/img/save.png" alt="" title="保存" v-if="item.show" @click.stop="saveGroup(item)">
                                <img src="@/assets/img/edit.png" alt="" title="编辑" v-else @click.stop="checkEdit(item)">
                                <img src="@/assets/img/close.png" alt="" title="取消" v-if="item.show" @click.stop="item.show = false">
                                <img src="@/assets/img/del.png" alt="" title="删除" v-else @click.stop="delGroup(item)">
                            </span>
                        </div>
                        <div class="day" v-if="item.periodDescription!=undefined">{{item.periodDescription }}的{{item.openTime | timeStamp}}点-{{item.closeTime | timeStamp}}点开启</div>
                        <div class="all row-center">
                            <span @click="GroupAllSwitch(true)">一键全开</span>
                            <span @click="GroupAllSwitch(false)">一键全关</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="search row-center">
                    <span>{{noall?'全部':selectLeftInfo.groupName}}</span>
                    <div class="grop">
                        <el-input v-model="keyword" style="width:280rem" placeholder="输入名称搜索开关"></el-input>
                        <el-select v-model="state"  style="width:120rem;margin-left:10px" placeholder="请选择">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="list"  v-if="result.length>0" :class="!noall?'control':''">
                    <div class="item " v-for="(item,index) in result" :key="index" :class="{disabled:item.disabled||item.SwitcnStatus==0||item.SwitchRemoteStatus==0}">
                        <div class="name"  :title="item.name">
                            <span class="checkbox"><el-checkbox v-model="item.checked"  @change="checkItem(item)" v-if="!item.disabled&&item.SwitcnStatus!=0&&item.SwitchRemoteStatus!=0"></el-checkbox></span>
                            <span class="tt"> {{item.name}}</span>
                            <img src="@/assets/img/Remove.png" class="Remove" :style="item.disabled?'cursor:no-drop':''" @click="!item.disabled&&DeviceDel(item)" v-if="!noall">
                        </div>
                        <div class="time" ><span v-if="!noall">{{getDay}}</span></div>
                        <div class="switch">
                            <span v-if="item.SwitchRemoteStatus==0"  class="yuan">就地</span>
                            <span v-if="item.SwitchRemoteStatus==1">远方</span>
                            
                            <!-- {{item.SwitchRemoteStatus}}
                            {{item.disabled}}
                            {{item.SwitcnStatus}}
                            {{item.subLoopUrl}} -->
                            <div class="statue" >
                                <!-- v-if="item.loading" -->
                                <div class="el-loading-mask" v-if="item.loading"><div class="el-loading-spinner" style="margin-top:-12px"><i class="el-icon-loading"></i></div></div>
                                <label v-if="item.val" class="open" @click="switchClick(index)">开</label>
                                <el-switch
                                ref="switch"
                                v-model="item.val"
                                @change="chageSwitch(item)"
                                :disabled="item.disabled||item.SwitcnStatus==0||item.SwitchRemoteStatus==0"
                                active-color="#0D94FF"
                                inactive-color="#999999">
                                </el-switch>
                                <label v-if="!item.val" class="closed" @click="switchClick(index)">关</label>
                            </div>
                        </div>
                        <div class="warm" v-if="item.disabled" @click="reasonControl('SwitchOn')"><i class="el-icon-warning-outline"></i>通讯失败 <i class="el-icon-arrow-right"></i></div>
                        <div class="warm" v-else-if="item.SwitchRemoteStatus==0" @click="reasonControl('SwitchRemoteStatus')"><i class="el-icon-warning-outline"></i>“就地”模式无法远控 <i class="el-icon-arrow-right"></i></div>
                        <div class="warm" v-else-if="item.SwitcnStatus==0" @click="reasonControl('SwitcnStatus')"><i class="el-icon-warning-outline"></i>断路器未合闸 <i class="el-icon-arrow-right"></i></div>
                    </div>
                </div>
                <div class="land row-center"  v-if="result.length>0">
                    <el-checkbox v-model="Allchecked" class="all">全选</el-checkbox>
                    <span class="open" @click="allSwitch(true)">开</span>
                    <span class="close" @click="allSwitch(false)">关</span>
                    <el-checkbox v-model="saveCheck" class="seave" v-if="noall">保存到开关列表</el-checkbox>
                    <span>已选 {{selist.length}} /共{{result.length}}</span>
                </div>
                <div class="page row-center"  v-else>
                    <img src="@/assets/img/not_found_data.png" alt="">
                </div>
                
                <div class="policy" v-if="!noall&&result.length>0">
                    <div class="title">策略控制  <span @click="periodSet()">去设置</span></div>
                    <div class="p" v-if="selectLeftInfo.periodDescription">定时策略：{{ selectLeftInfo.periodDescription }}的{{ selectLeftInfo.openTime }}开启，{{ selectLeftInfo.closeTime }}关闭</div>
                    <div class="p" v-else>定时策略：无</div>
                </div>
            </div>
        </div>

        <el-dialog
            class="dialogControl"
            title="无法控制的可能原因"
            :visible.sync="dialogControl"
            width="596px"
            :before-close="handleClose">
            <div class="cont">
                <p>1.通讯失败，请检查设备通讯；</p>
                <p>2.当前为就地状态，请调整为远方状态；</p>
                <p>3.电操为远方状态，但是断路器为分闸状态且不支持远程控制，请先将断路器合闸；</p>
            </div>
        </el-dialog>

        <el-dialog
            class="dialogSwitch"
            title="开关操作"
            :visible.sync="dialogSwitch"
            width="596px"
            :before-close="handleSwitchClose">
            <div class="cont">
                <div class="name">{{dialogInfo.name}} 即将“<i style="color:#0D94FF">{{dialogInfo.val?"关":'开'}}</i>”</div>
                <!-- <div class="pwd">
                    <p>请输入控制密码，确认此操作</p>
                    <div class="input-box row-center">
                        <div class="code-item" :class="codeValue.length == 0 && inputFocus ? 'code-item-active' : ''">{{codeValue[0] | filterVal}}</div>
                        <div class="code-item" :class="codeValue.length == 1 && inputFocus ? 'code-item-active' : ''">{{codeValue[1]| filterVal}}</div>
                        <div class="code-item" :class="codeValue.length == 2 && inputFocus ? 'code-item-active' : ''">{{codeValue[2]| filterVal}}</div>
                        <div class="code-item" :class="codeValue.length == 3 && inputFocus ? 'code-item-active' : ''">{{codeValue[3]| filterVal}}</div>
                        <el-input class="input-code"
                        :value="codeValue"
                        :maxlength="4"
                        @blur="codeInputBlur"
                        @focus="codeInputFocus"
                        @input="codeInputChange">
                        </el-input>
                    </div>
                </div> -->
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="cancel" @click="handleSwitchClose">取 消</el-button>
                <el-button type="primary" :loading="dialogSwitchBtnLoading" class="sub" v-if="dialogSwitchBtnLoading">请求中</el-button>
                <el-button type="primary" class="sub" @click="dialogSwitchBtn" v-else>确 定</el-button>
            </span>
        </el-dialog>
        
        <el-dialog
            class="dialogPolicy"
            title="编辑"
            :visible.sync="dialogPolicy"
            width="596px"
            :before-close="handlePolicyClose">
                <el-form :model="ruleForm" :rules="rules" label-position="left" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="周期" prop="period">
                        <el-select v-model="ruleForm.period" multiple placeholder="请选择" @change="describeCh" style="width:300px">
                            <el-option
                            v-for="item in cycleOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开启时间" prop="openTime" >
                        <el-time-picker
                        v-model="ruleForm.openTime"
                        format='HH:mm'
                        value-format="HH:mm"
                        placeholder="开启时间" style="width:300px">
                        </el-time-picker>
                    </el-form-item>
                    <el-form-item label="关闭时间" prop="closeTime">
                        <el-time-picker
                        v-model="ruleForm.closeTime"
                        format='HH:mm'
                        value-format="HH:mm"
                        placeholder="关闭时间" style="width:300px">
                        </el-time-picker>
                    </el-form-item>
                    <el-form-item>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="cancel" @click="cancelPolicy()">取消</el-button>
                    <el-button class="sub" type="primary" @click="submitForm('ruleForm')">确定</el-button>
                </div>
        </el-dialog>

        <el-dialog
            class="dialogTips"
            title="提示"
            :visible.sync="dialogTips"
            width="596px"
            :before-close="handleCloseTips">
            <div class="cont">
                <div class="rule">这些设备在分组已经设置过定时策略，确认更改为新规则吗？ </div>
                <div class="box">
                    <div class="li" v-for="item in DetermineList">
                        <div class="name">“{{item.loopName}}”</div>
                        <div class="del"><span>“{{item.groupName}}”</span><img src="@/assets/img/right-arrow.png" alt=""><span>“{{selectLeftInfo.groupName}}”</span></div>
                    </div>
                </div>
                <div class="rule">更改成功后，<i style="color:#0D94FF" v-if="DetermineList.length>0">“{{DetermineList[0].loopName}}”</i>等设备将自动移出这些分组,移入“{{selectLeftInfo.groupName}}”分组 </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="cancel" @click="handleTipsClose">取 消</el-button>
                <el-button type="primary" class="sub" @click="dialogTipsBtn" >确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { time } from 'echarts';
import { clist,ctrl,ctrlAdd,ctrlGroupList,ctrlGroupUpdate,ctrlGroupDelete,ctrlDeviceDel,groupIdList,appControl,loopCtrl,cronUpdate,groupCheck} from "../../api/power";
import {subscribe1,subscribe, unsubscribe1,connect, disconnect} from "../../mqtt/index";
import { timeStamp } from 'console';
export default {
    components: { 
        
    },
    data () {
        return {
            DetermineList:[],  //定时策略
            dialogTips:false,
            ruleForm:{
                period:[],
                openTime:"",
                closeTime:"",
                periodDescription:""
            },
            cycleOptions: [{
                value: '1',
                label: '周一'
                }, {
                value: '2',
                label: '周二'
                }, {
                value: '3',
                label: '周三'
                }, {
                value: '4',
                label: '周四'
                }, {
                value: '5',
                label: '周五'
                }, {
                value: '6',
                label: '周六'
                }, {
                value: '7',
                label: '周日'
            }],
            rules:{
                period: [
                    { required: true, message: '请选择周期', trigger: ['change','blur']},
                ],
                openTime: [
                    { required: true, message: '请选择开启时间', trigger: ['blur'] }
                ],
                closeTime: [
                    { required: true, message: '请选择关闭时间', trigger: ['blur'] }
                ]
            },
            dialogPolicy:false,
            options: [{
                value: "",
                label: '全部'
                },{
                value: '1',
                label: '开'
                }, {
                value: '0',
                label: '关'
            }],
            keyword:"",
            state: "",
            list:[],
            listCopy:[],
            activeIndex:"",
            Allchecked:false,
            selist:[],
            saveCheck:false,
            leftList:[],
            noall:true,
            selectLeftInfo:{}, //选中左侧信息
            dialogControl:false,
            dialogSwitch:false,
            codeValue: '',
            inputFocus: false,
            dialogInfo:{
                name:"",
                val:"",
                list:[]
            },
            dialogSwitchBtnLoading:false
        }
    },
    filters:{
        filterVal(value) {
            if(value){
                return '*';
            }
        },
        timeStamp(val) {
            if(val){
                return val.split(":")[0];
            }
        }
    },
    computed:{
        getDay(){
            let date = new Date()
            if(this.selectLeftInfo.period){
                if(this.selectLeftInfo.period.indexOf(date.getDay().toString())!=-1){
                    let now = date.getHours()+ ":"+date.getMinutes();
                    if(this.selectLeftInfo.closeTime>now){
                        return "将在今日" +this.selectLeftInfo.closeTime +"关闭"
                    }
                    if(now>this.selectLeftInfo.openTime && now<this.selectLeftInfo.closeTime){
                        return "将在今日" +this.selectLeftInfo.openTime +"开启"
                    }
                }
            }
            
        },
        mqttval() {
			return this.getMqttVal(this.$store.getters.mqttVal);
		},
        result(){
            let data = []
            if(this.list){
                data = this.list.filter(e=>{
                    let mqtt = ""
                    let SwitchRemoteStatus = ""
                    let SwitcnStatus = ""
                    let SwitchError = ""
                    if(e.addrIndex){
                        mqtt = this.mqttval('CTRL/'+e.addrIndex)
                    }
                    if(e.subLoopUrl){
                        mqtt = this.mqttval(e.subLoopUrl+ "/SwitchOn")
                        SwitchRemoteStatus = this.mqttval(e.subLoopUrl+ '/SwitchRemoteStatus')  //就地0 远方1
                        SwitcnStatus = this.mqttval(e.subLoopUrl+ '/SwitcnStatus')  //断路器是否可控
                        SwitchError = this.mqttval(e.subLoopUrl+ '/SwitchError')  //故障状态

                        e.SwitchRemoteStatus = SwitchRemoteStatus
                        e.SwitcnStatus = SwitcnStatus
                        e.SwitchError = SwitchError
                    }
                    if(mqtt==0){
                        e.val = false
                        e.disabled = false
                    }else if(mqtt==1){
                        e.val = true
                        e.disabled = false
                    }else if(mqtt==-1){
                        e.disabled = true
                    }
                    
                    if(e.name.indexOf(this.keyword)!== -1){
                        // e.val = this.mqttval('CTRL/'+e.addrIndex);
                        return e
                    }
                }).filter(e=>{
                    let mqtt = ""
                    if(e.addrIndex){
                        mqtt = this.mqttval('CTRL/'+e.addrIndex)
                    }
                    if(e.subLoopUrl){
                        mqtt = this.mqttval(e.subLoopUrl+ "/SwitchOn")
                    }
                    if(this.state==""){
                        return e
                    }else if(mqtt===this.state){
                        return e
                    }
                })

                // 索引数组(需要移动的元素索引数组)
                var sourceIndexes = [];
                data.forEach((item, index) => {
                    if (item.disabled||item.SwitchRemoteStatus==0||item.SwitcnStatus==0) {
                        sourceIndexes.push(index);
                    }
                });
                
                // 遍历索引数组，移动元素
                sourceIndexes.forEach((sourceIndex) => {
                    this.moveArray(data, sourceIndex, data.length);
                });
                // console.log(data);
                
                // 过滤数组，去除 undefined 项
                data = data.filter((item) => {
                    return item !== undefined || !!item;
                });
                // console.log(data);
                // this.list = data
            }else{
                this.list = []
            }
            return  data
        }
    },
    watch:{
        Allchecked(n,o){
            this.list.filter(e=>{e.checked=n;return e})
            if(n){
                this.selist = this.list.filter(e=>!e.disabled)
            }else{
                this.selist = []
            }
        },
        saveCheck(n,o){
            // if(this.selist.length>0){
                if(n){
                    this.saveAdd()
                }
                
            // }else{
                // this.$message({
                //     message: '请选择！',
                //     type: 'warning'
                // });
            // }
        }
    },
    mounted(){
        this.getClist();
        this.getLeftList()
    },
    methods:{
        periodSet(){
            if(this.selectLeftInfo.period){
                this.ruleForm.period = this.selectLeftInfo.period.split(",");
                this.ruleForm.openTime = this.selectLeftInfo.openTime;
                this.ruleForm.closeTime = this.selectLeftInfo.closeTime;
                this.ruleForm.periodDescription = this.selectLeftInfo.periodDescription.split(",");
            }else{
                this.ruleForm = {
                    openTime:"",
                    closeTime:"",
                    periodDescription:""
                }
                // this.ruleForm.period = []
                // this.ruleForm.openTime = ""
                // this.ruleForm.closeTime = ""
                // this.ruleForm.periodDescription = ""
            }
            this.dialogPolicy = true;
        },
        handleTipsClose(){
            this.dialogTips = false
        },
        dialogTipsBtn(){
            this.subCronUpdate()
        },
        handleCloseTips(){
            this.dialogTips = false
        },
        cancelPolicy(){
            this.dialogPolicy = false
        },
        describeCh(val){
            let newList = []
            val.map(v => {
                const list = this.cycleOptions.filter(item => {
                return item.value === v
                })
                let obj = list[0]
                newList.push(obj.label)
            })
            this.ruleForm.periodDescription = newList
        },
        sortWeeks:function(weeks){
            var _weeks = [];//创建临时排序的数组
            for(var i = 0;i<weeks.length;i++){
                if(weeks[i] == "周一"){
                    var _week = {};
                    _week["id"] = 1;
                    _week["name"] = "周一";
                    _weeks.push(_week);
                }
                if(weeks[i] == "周二"){
                    var _week = {};
                    _week["id"] = 2;
                    _week["name"] = "周二";
                    _weeks.push(_week);
                }
                if(weeks[i] == "周三"){
                    var _week = {};
                    _week["id"] = 3;
                    _week["name"] = "周三";
                    _weeks.push(_week);
                }
                if(weeks[i] == "周四"){
                    var _week = {};
                    _week["id"] = 4;
                    _week["name"] = "周四";
                    _weeks.push(_week);
                }
                if(weeks[i] == "周五"){
                    var _week = {};
                    _week["id"] = 5;
                    _week["name"] = "周五";
                    _weeks.push(_week);
                }
                if(weeks[i] == "周六"){
                    var _week = {};
                    _week["id"] = 6;
                    _week["name"] = "周六";
                    _weeks.push(_week);
                }
                if(weeks[i] == "周日"){
                    var _week = {};
                    _week["id"] = 7;
                    _week["name"] = "周日";
                    _weeks.push(_week);
                }
            }
            _weeks.sort(function(a,b){return a.id - b.id;});
            //将weeks清空并将排序好的值赋给weeks
            weeks = [];
            for(var i = 0;i<_weeks.length;i++){
                weeks.push(_weeks[i].name);
            }
            return weeks;
        },
        async subCronUpdate(){
            let periodDescription = this.sortWeeks(this.ruleForm.periodDescription);
            let obj = {
                period:this.ruleForm.period.sort().join(","),
                openTime:this.ruleForm.openTime,
                closeTime:this.ruleForm.closeTime,
                periodDescription:periodDescription.join(","),
                id:this.selectLeftInfo.id
            }
            let result = await cronUpdate(obj);
            if(result.data.status){
                this.dialogPolicy = false
                this.dialogTips = false
                this.$message.success("保存成功！");
                
                // this.getLeftList();
                // this.list = item.deviceList
                let id = this.leftList.filter(e=>e.active)[0].id
                // this.getGroupIdList(id)
                this.getClist();
                this.getLeftList(id);
            }else{
                this.$message.success(result.data.errMsg);
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate(async(valid) => {
            if (valid) {
                
                // if(this.ruleForm.closeTime<=this.ruleForm.openTime){
                //     this.$message.error("关闭时间不能小于开启时间");
                //     return false
                // }
                // this.subCronUpdate()
                let obj = {
                    id:this.selectLeftInfo.id
                }
                let result = await groupCheck(obj);
                if(result.data.data.length>0){
                    this.dialogTips = true
                    this.DetermineList = result.data.data
                }else{
                    this.subCronUpdate()
                }

            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        handlePolicyClose(){
            this.dialogPolicy = false
        },
        // arr 需要排序的数组 ，sourceIndex 需要移动的元素的索引 ，targetIndex 目标索引
        moveArray(arr, sourceIndex, targetIndex) {
            // splice 将目标元素替换并将原结果扔回来赋值给它
            arr[sourceIndex] = arr.splice(targetIndex, 1, arr[sourceIndex])[0];
        },
        reasonControl(name){
            switch (name) {
                case 'SwitchOn':
                    this.$alert('无法连接到控制单元, 请检查控制设备的通讯状态与网络状态', '通讯失败', {
                        customClass: "message_box_control",
                        showCancelButton:false,
                        showConfirmButton:false,
                    });
                    break;
                case 'SwitchRemoteStatus':
                    this.$alert('操作机构处于“就地”模式, 请先调整操作机构至“远方”模式', '“就地”模式不支持远控', {
                        customClass: "message_box_control",
                        showCancelButton:false,
                        showConfirmButton:false,
                    });
                    break;
                case 'SwitcnStatus':
                    this.$alert('断路器当前处于分闸状态, 请先调整断路器至合闸状态', '断路器未合闸', {
                        customClass: "message_box_control",
                        showCancelButton:false,
                        showConfirmButton:false,
                    });
                    break;
                default:
                    break;
            }
        },
        // 验证码输入框
        codeInputChange(e) {
            if (e) {
            // 判断输入内容是否为数字
                if ((/^\+?[0-9][0-9]*$/).test(e)) {
                this.codeValue = e;
                }
            } else {
                this.codeValue = '';
            }
        },
        // 验证码输入框失去焦点
        codeInputBlur() {
            this.inputFocus = false;
        },
        // 验证码输入框获取到焦点
        codeInputFocus() {
            this.inputFocus = true;
        },
        handleSwitchClose(){
            this.dialogSwitch = false
            this.codeValue = ""
        },
        handleClose(){
            this.dialogControl = false
        },
        switchClick(index){
            this.$refs.switch[index].$el.click()
        },
        //编辑按钮
        checkEdit(item){
            this.leftList.filter(e=>{e.active=false;e.show=false;return e})
            item.show = true;
            item.active = true
            this.noall = false
            this.selectLeftInfo = item
            this.getGroupIdList(item.id)
        },
        //组开关
        GroupAllSwitch(val){
            let name = ""
            if(this.result.length>3){
                name = this.result.filter((e,i)=>i<3).map(e=>e.name).toString().toString()+"..."
            }else{
                name = this.result.map(e=>e.name).toString()
            }
            
            if(this.result.filter(e=>e.disabled).length==this.result.length){
                this.$message.warning("暂无可控回路！")
                return false
            }
            this.dialogSwitch = true;
            this.dialogInfo = {
                name:name,
                val:!val,
                list : this.result
            }
            return false
            
        },
        //查询单个组的列表
        getGroupIdList(id){
            groupIdList(id).then(res=>{
                let list =  res.data.data.chDeviceList||[]
                if(res.data.data.deviceList){
                    res.data.data.deviceList.forEach(item=>{
                        list.push({
                            name:item.loopName,
                            id:item.loopId,
                            ...item
                        })
                    })
                }
                this.list = list.filter(e=>{e.checked=false;return e})||[]
            })
        },
        //删除单个设备
        DeviceDel(item){
            let id = this.leftList.filter(e=>e.active)[0].id
            this.$confirm("确认要将 “<i style='color:#0D94FF'>"+item.name+"</i>” 移出<i>"+this.selectLeftInfo.groupName+"</i>？<br> 同时组内的定时策略将失效。", '分组调整', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: '',
                customClass: "message_box"
            }).then(() => {
                ctrlDeviceDel({groupId:id,ids:item.id}).then(res=>{
                    // this.getLeftList()
                    this.getGroupIdList(id)
                    this.$message({
                        message: '操作成功！',
                        type: 'success'
                    });
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
            
        },
        //保存名称
        saveGroup(item){
            if(item.groupNameCopy==""||item.groupNameCopy.length>8){
                this.$message.error("名称不能为空，且最多为8个字符")
                return
            }
            ctrlGroupUpdate({groupId:item.id,groupName:item.groupNameCopy}).then(res=>{
                // this.getLeftList()
                // item.active = true
                item.groupName = item.groupNameCopy
                item.show = false
                this.$message({
                    message: '操作成功！',
                    type: 'success'
                });
            })
        },
        //删除分组
        delGroup(item){
            ctrlGroupDelete({groupId:item.id}).then(res=>{
                this.getLeftList()
                this.$message({
                    message: '操作成功！',
                    type: 'success'
                });
                this.noall = true
                this.list = this.listCopy
            })
        },
        //选中组
        checkGroup(type,item,index){
            if(type=='group'){
                this.leftList.filter(e=>{e.active=false;e.show=false;return e})
                item.active = true
                this.noall = false
                this.getGroupIdList(item.id)
                // this.list = item.deviceList
                this.selectLeftInfo = item
                this.selist = []
            }else{
                this.leftList.filter(e=>{e.active=false;e.show=false;return e})
                this.noall = true
                this.list = this.listCopy
                this.list.filter(e=>{e.checked=false;return e})
                this.selist = []
            }
        },
        //组列表
        getLeftList(id){
            let obj = {
                projectId:this.$store.getters.projectId,
                controlType:"switch"
            }
            ctrlGroupList(obj).then(res=>{
                this.leftList = res.data.data.map(e=>{
                    e.groupNameCopy = e.groupName;
                    e.show = false;
                    if(id==e.id){
                        e.active = true; 
                        this.getGroupIdList(id)
                    }else{
                        e.active = false; 
                    }
                    return e
                })
                if(id){
                    this.selectLeftInfo = this.leftList.filter(e=>e.id==id)[0]
                }
            })
        },
        //保存开关列表
        saveAdd(){
            if(this.selist.length==0){
                this.$message({
                    message: '请选择！',
                    type: 'warning'
                });
                this.saveCheck = false
                return
            }
            // let ids = this.selist.map(e=>{
            //     if(e.subLoopUrl){
            //         return e.loopId
            //     }else{
            //         return e.id
            //     }
            // })
            let ids = this.selist.map(e=>e.id)
            let obj = {
                ids:ids.join(','),
                projectId:this.$store.getters.projectId,
                controlType:"switch"
            }
            ctrlAdd(obj).then(res=>{
                this.list.filter(e=>{e.checked=false;return e})
                this.getLeftList()
                this.selist = []
                this.$message({
                    message: '操作成功！',
                    type: 'success'
                });
                setTimeout(item=>{
                    this.saveCheck = false
                },100)
                
            })
        },
        //全开
        allSwitch(val){
            let name = ""
            if(this.selist.length>3){
                name = this.selist.filter((e,i)=>i<3).map(e=>e.name).toString().toString()+"..."
            }else{
                name = this.selist.map(e=>e.name).toString()
            }
            // console.log(this.selist,"this.selist")
            if(this.selist.length==0){
                this.$message.warning("请选择")
                return false
            }
            if(this.selist.filter(e=>e.disabled).length==this.selist.length){
                this.$message.warning("暂无可控回路！")
                return false
            }
            // this.dialogSwitch = true;
            this.dialogInfo = {
                name:name,
                val:!val,
                list : this.selist
            }
            this.dialogSwitchBtn();
            return false
            
        },
        checkItem(item){
            if(item.checked){
                this.selist.push(item)
            }else{
                this.selist.forEach((elm,index)=>{
                    if(elm.checked==item.checked){
                        this.selist.splice(index,1)
                    }
                })
            }
        },
        dialogSwitchBtn(){
            // if(this.codeValue==""){
            //     this.$message.error("密码不能为空！");
            //     return false
            // }
            // if(this.codeValue!="0000"){
            //     this.$message.error("密码错误！");
            //     return false
            // }
            this.dialogSwitchBtnLoading = true
            this.dialogInfo.list.forEach(item=>{
                item.loading = true
                this.dialogSwitch = false
                if(item.subLoopUrl){ 
                    let obj = {
                        loopId:item.loopId,
                        status:this.dialogInfo.val?0:1,
                        type:item.controlType
                    }
                    loopCtrl(obj).then(res=>{
                        if (res.data.status) {
                            this.selist = []
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            });
                            // this.result.forEach(e=>{
                            //     if(item.id==e.id){
                            //         item.val = !item.val
                            //     }
                            // })
                            this.dialogSwitchBtnLoading = false
                            this.dialogSwitch = false
                            this.codeValue = ""
                            item.loading = false
                        }else{
                            this.$message.error(res.data.errMsg);
                            this.dialogSwitchBtnLoading = false
                            item.loading = false
                            
                        }
                    })
                }else{
                    let obj = {
                        id:item.id,
                        b:!this.dialogInfo.val
                    }
                    ctrl(obj).then(res=>{
                        if (res.data.status) {
                            this.selist = []
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            });
                            // this.result.forEach(e=>{
                            //     if(item.id==e.id){
                            //         item.val = !item.val
                            //     }
                            // })
                            this.dialogSwitchBtnLoading = false
                            this.dialogSwitch = false
                            this.codeValue = ""
                            item.loading = false
                        }else{
                            this.$message.error(res.data.errMsg);
                            this.dialogSwitchBtnLoading = false
                            item.loading = false
                        }
                    })
                }
            })

        },
        chageSwitch(item){
            item.val = !item.val
            // this.dialogSwitch = true;
            this.dialogInfo = {
                name:item.name,
                val:item.val,
                list : [item]
            }
            
            this.dialogSwitchBtn();
            return false
            
        },
        getMqttVal(f) {
			return (k, m) => {
				if (k) {
                    let mqttVal = f(k);
                    return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "-1";
				} else {
				    return "-1";
				}
			};
		},
        async getClist(){
            // let result = await clist(); //五楼
            let result1 = await appControl()  //一楼
            let data = []
            let data1 = []
            for(i in result1.data.data.list){
                let arr = result1.data.data.list[i]
                data1 = data1.concat(arr)
            }
            let list = data.map(e=>{e.checked = false;return e})
            data1.forEach(item=>{
                list.push({
                    name:item.loopName,
                    id:item.loopId,
                    ...item
                })
            })
            this.list = list
            this.listCopy = this.list
            this.list.forEach(element => {
                if(element.addrIndex){
                    subscribe1([element.addrIndex])
                }
                if(element.subLoopUrl){
                    subscribe([element.subLoopUrl]);
                }
            });
            
        },
    }
}
</script>
<style lang="less" scoped>
/deep/ .dialogTips {
    .el-dialog__body{
        padding:0px 30px 20px 30px;
    }
    .rule{
        font-size: 22rem;
        margin: 10px 0;
    }
    .box{
        max-height: 220px;
        border: 1px solid #B6BDC4;
        border-radius: 2px;
        overflow: auto;
        padding: 0 10px;
        width: 510rem;
        margin-top: 20rem;
        .li{
            border-bottom: 1px solid #B6BDC4;
            // height: 92rem;
            padding:8rem 0;
            .name{
                color: #0D94FF;
                font-size: 20rem;
            }
            .del{
                font-size: 20rem;
            }
            img{
                vertical-align: middle;
                margin: 0 30rem;
            }
        }
        .li:last-child{
            border:0;
        }
    }
}

.policy{
    height: 103px;
    background: #FFFFFF;
    box-shadow: 0px 0px 35px 0px rgba(0,0,0,0.08);
    border-radius: 8px 6px 6px 6px;
    bottom: 66px;
    position: absolute;
    width: 96%;
    z-index: 11;
    font-size: 18rem;
    padding:20rem;
    right:20px;
    left:20px;
    .title{
        margin-bottom: 10rem;
        span{
            color: #0D94FF;
            font-size: 18rem;
            float: right;
            cursor: pointer;
        }
    }
}

.dialogSwitch{
    .cont{
        font-size: 18rem;
        .name{
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            line-height: 32px;
        }
        .pwd{
            margin:20px auto;
            text-align: center;
            p{
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
            }
        }
    }
  .input-box {
    margin-top: 10px;
    position: relative;
  }
  .input-code {
    position: absolute;
    left: 0;
    opacity: 0;
  }
  .code-item {
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-bottom: 1px solid #999999;
    margin:0 20px;
    display: inline-block;
  }
  .code-item-active {
    border-bottom: 1px solid #0D94FF;
    // box-sizing: border-box;
  }
  // 隐藏input
  .input-box {
    .el-input__inner {
      width: 362px;
      height: 50px;
      background-color: transparent;
      border: none;
      color: transparent;
    }
  }

}
.dialogControl{
    
 .cont{
    font-size: 18rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
    height: 220px;
 }
}
.page {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    min-width: 0;
    height: 100%;
}
.SwitchControl{
    background: #ffffff;
    height: 100%;
    width: 100%;
    .p-title{
        font-size: 18rem;
        font-weight: bold;
        height: 45rem;
        line-height: 45rem;
        padding-left: 20rem;
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    }
    .p-cont{
        height: calc(100% - 45rem);
        padding: 16rem 0 16rem 16rem;
        justify-content: space-between;
        align-items: flex-start;
        display:flex;
        .left{
            box-shadow: 0px 2px 8px 0px rgba(8,1,3,0.12);
            .w(300);
            height: 100%;
            padding: 0 10rem;
            position: relative;
            z-index: 99;
            .tt{
                span{
                    color: #0D94FF;
                    font-size: 18rem;
                    border-top: 2px solid #0D94FF;
                    padding: 10rem 0;
                    display: inline-block;
                }
            }
            .list{
                height: calc(100% - 50px);
                overflow: auto;
                .item{
                    background: #F5F6F7;
                    border: 2px solid #F5F6F7;
                    padding:14rem 10rem;
                    // .h(140);
                    margin-bottom: 18rem;
                    cursor: pointer;

                    .day{
                        color: #0D94FF;
                        font-size: 14px;
                    }
                    .name{
                        font-size: 24rem;
                        font-weight: bold;
                        height: 41rem;
                        justify-content: space-between;
                        img{
                            cursor: pointer;
                            float: left;
                            margin-left:4px
                            // height: 20px;
                        }
                        span{
                            float: right;
                        }
                        input{
                            width: 75%;
                            height: 41rem;
                            background: #FFFFFF;
                            border: 1px solid #CCCCCC;
                            border-radius: 2px;
                            padding-left: 5px;
                            font-size: 24rem;
                            font-weight: bold;
                        }
                    }
                    .all{
                        justify-content: space-between;
                        margin-top: 15px;
                        span{
                            .w(104);
                            height: 32px;
                            line-height: 32px;
                            background: #0D94FF;
                            border-radius: 16px;
                            color:#ffffff;
                            display: inline-block;
                            text-align: center;
                            font-size: 16rem;
                            cursor: pointer;
                        }
                    }
                }
                
                .active{
                    border: 2px solid #0D94FF;
                }
            }
        }
        .right{
            // .w(860);
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            flex: 1;
            min-width: 0;
            height: 100%;
            position: relative;
            .search{
                justify-content: space-between;
                height: 50px;
                span{
                    font-size: 24rem;
                    font-weight: bold;
                }
                padding:0 20px;
            }
            .land{
                height: 56px;
                background: #FFFFFF;
                box-shadow: 0px -6px 8px 0px rgba(8,1,3,0.08);
                bottom: 0;
                position:absolute;
                z-index: 2;
                width: 100%;
                justify-content:flex-start;
                padding: 0 15px;
                font-size: 16rem;
                z-index: 11;
                span{
                    color: #999999;
                    margin-left: 15%;
                }
                .open{
                    width: 104px;
                    height: 32px;
                    line-height: 30px;
                    background: #0D94FF;
                    border: 2px solid #0D94FF;
                    border-radius: 16px;
                    color:#ffffff;
                    display: inline-block;
                    text-align: center;
                    font-size: 16rem;
                    cursor: pointer;
                    margin-left: 20px;
                }
                .close{
                    width: 104px;
                    height: 32px;
                    line-height: 30px;
                    background: #FFFFFF;
                    border: 2px solid #999999;
                    border-radius: 16px;
                    color:#999999;
                    display: inline-block;
                    text-align: center;
                    font-size: 16rem;
                    cursor: pointer;
                    margin-left: 20px;
                }
                .all{
                    margin-right: 20px;
                }
                .seave{
                    margin-left: 40px;
                }
            }
            .list{
                // justify-content: space-between;
                padding-top: 20px;
                height: calc(100% - 56px);
                overflow: auto;
                padding-left: 20px;
                padding-bottom: 60px;
                .item{
                    width: 24%;
                    .h(145);
                    background: #FFFFFF;
                    box-shadow: 0px 2rem 8rem 0px rgba(8,1,3,0.12);
                    border-radius: 8rem;
                    padding: 10rem 15rem 0 15rem;
                    font-size: 18rem;
                    margin-bottom: 8rem;
                    float: left;
                    margin-right: 8rem;
                    position: relative;
                    
                    .time{
                        color: #0D94FF;
                        font-size: 16rem;
                        padding-left: 20rem;
                        height: 20px;
                    }
                    .name{
                        height: 25px;
                        line-height: 25px;
                        .Remove{
                            cursor: pointer;
                            float: right;
                            line-height: 40rem;
                        }
                        .checkbox{
                            width:15px;
                            display: inline-block;
                            vertical-align: middle;
                        }
                        .tt{
                            font-size: 18rem;
                            vertical-align: middle;
                            width:78%;
                            overflow:hidden;
                            text-overflow:ellipsis;
                            word-break:break-all;
                            white-space: nowrap;
                            display: inline-block;
                        }
                    }
                    
                    .switch{
                        clear: both;
                        text-align: center;
                        margin-top: 15rem;
                        justify-content: space-between;
                        // position: absolute;
                        // bottom: 20px;
                        // right:30px;
                        span{
                            width: 50rem;
                            height: 24rem;
                            line-height: 24rem;
                            background: #01AB65;
                            border-radius: 3px;
                            color:#ffffff;
                            display: inline-block;
                            font-size: 16rem;
                            float:left;
                            margin-top: 3rem;
                            
                        }
                        .yuan{
                            background: #5D7092;
                        }
                        .statue{
                            position: relative;
                            float: right;
                            margin-right: 20px;
                            height: 32rem;
                                .closed{
                                    position: absolute;
                                    right: 33%;
                                    color:#ffffff;
                                    line-height: 32rem;
                                    z-index: 9;
                                    cursor: pointer;
                                }
                                .open{
                                    position: absolute;
                                    left: 33%;
                                    color:#ffffff;
                                    line-height: 32rem;
                                    z-index: 9;
                                    cursor: pointer;
                                }
                        }
                        
                        .el-switch{
                            // margin-left: 35%;
                        }
                        /deep/.el-switch__core{
                            height: 32rem;
                            width: 80rem !important;
                            border-radius: 16px;
                        }
                        /deep/.el-switch__core:after{
                            width: 24rem;
                            height: 24rem;
                            // margin-left: -22px;
                            top: 2.5rem;
                            left:2px;
                        }
                        /deep/.el-switch.is-checked .el-switch__core{
                            background: #65C365;
                            border-color:#65C365
                        }
                       /deep/ .el-switch.is-checked .el-switch__core::after{
                            left: inherit;
                            right: 2px;
                       }
                    }
                    .warm{
                        font-size: 13px;
                        font-weight: 400;
                        color: #F5AA00;
                        clear: both;
                        line-height: 32px;
                        cursor: pointer;
                        img{
                            width:16px;
                            vertical-align: -2px;
                            margin-right: 4px;
                        }
                        .el-icon-warning-outline{
                            transform: rotate(180deg);
                            font-size: 18px;
                            vertical-align: -2px;
                        }
                        .el-icon-arrow-right{
                            color:#666666;
                            font-weight: bold;
                        }
                    }
                }
                .disabled{
                    background: #F6F6F6;
                    box-shadow: 0px 1rem 4rem 0px rgba(8,1,3,0.12);
                    // opacity: 0.6;
                    cursor:no-drop;
                    // .switch{
                    //     span{
                    //         color: #BEBEBE;
                    //         background: #E9E9EB;
                    //     }
                    // }
                    .el-checkbox{
                        color:#BEBEBE;
                    }
                    /deep/ .el-checkbox .el-checkbox__label{
                        color:#333 !important
                    }
                    /deep/ .el-switch.is-disabled{
                        opacity: 0.2;
                    }
                    .closed{
                        color: #BEBEBE !important;
                    }
                    .warm{
                        
                    }
                }
            }
            .list.control{
                height: calc(100% - 170px);
            }
        }
    }
}
</style>